import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const outsideCarouselHeading = css`
  padding: 0 ${spacing.sm}px 2px 0;
  position: relative;
  white-space: nowrap;
  ${responsiveText.BODY.MD}
  flex-shrink: 0;
`;

export const linkCarousel = css`
  display: flex;
  justify-content: left;
  align-items: center;
`;

export const carouselContentWrapper = css`
  overflow: hidden;
  overflow-x: auto;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      overflow-x: hidden;
    `,
  )};
`;

export const carouselContent = css`
  display: flex;
  align-items: center;
  width: 100%;
  transition: transform 0.5s;
`;

export const links = css`
  display: flex;
  flex-shrink: 0;
  padding: 0;
  gap: ${spacing.xl}px;
`;

export const carouselControls = css`
  display: flex;
  margin: 0 ${spacing.xs}px;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: none;
    `,
  )};

  button {
    transition: opacity 0.4s;

    &:first-of-type {
      margin-right: 4px;
    }

    &:disabled {
      opacity: 0.3;
    }
  }

  img {
    width: ${spacing.md}px;
    height: ${spacing.md}px;
  }
`;

export const itemLink = css`
  ${responsiveText.BODY.SM}
  margin: 0;
  list-style: none;
`;

export const link = css`
  text-decoration: none;
  color: ${palette.blueBase};
  font-weight: normal;
  display: inline-block;

  &:hover {
    text-shadow: 0.8px 0 0 currentColor;
    text-decoration: underline;
  }
`;
